<template>
  <div class="pdp-purchase-options" role="group">
    <div class="pdp-purchase-container">
      <div class="pdp-purchase-one-time">
        <div class="pdp-purchase-option-main">
          <h5>{{ translations.oneTime.title }}</h5>
          <span v-if="shopifyEnv != 'myflavia'">
            {{ translations.oneTime.subTitle }}
          </span>
        </div>
        <div class="pdp-purchase-option-price">
          <strong>{{ selectedVariant.formattedPrice }}</strong>
          <span class="pdp-purchase-option-price-compare">
            {{ selectedVariant.formattedCompareAtPrice }}
          </span>
        </div>
        <div
          v-if="variants && variants.length > 1"
          class="pdp-purchase-option-dropdown-select"
        >
          <select @change="onChange">
            <option
              v-for="variant in variants"
              :key="variant.id"
              :value="variant.id"
              :selected="variant.id === selectedVariant.id"
            >
              {{ variant.title }}
            </option>
          </select>
          <svg class="icon icon-cheveron-down">
            <use xlink:href="#icon-cheveron-down" />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { purchaseForm, mutations } from './store';

export default {
  computed: {
    ...mapState(purchaseForm, [
      'oneTime',
      'variants',
      'translations',
      'selectedVariant'
    ]),

    shopifyEnv() {
      return __SHOPIFY_ENV__;
    }
  },

  methods: {
    ...mapMutations({
      selectVariant: `${purchaseForm}/${mutations.SELECT_VARIANT}`
    }),

    onChange($event) {
      this.selectVariant($event.target.value);
    }
  }
};
</script>
